export const AWS_REGION = 'eu-west-1';

const PAYLOAD_PREVIEW_MAX_SIZE = 70_000_000;

export function isPreviewAvailable(payloadSize?: number | null): boolean {
    return payloadSize != null && payloadSize < PAYLOAD_PREVIEW_MAX_SIZE;
}

export function formatDateTime(
    value?: string | null,
    options?: { includeSeconds?: boolean }
): string {
    if (!value) return '—';
    try {
        const date = new Date(value);
        return date.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            ...(options?.includeSeconds ? { second: '2-digit' } : {}),
        });
    } catch {
        return value;
    }
}
